import React from 'react';
import { IoCloseSharp } from 'react-icons/io5';
import { PropsFromRedux } from '.';
import ModalWrapper from '../common/ModalWrapper';
import EditDropOffForm from '../DropoffList/EditDropOffForm';
import { DROPOFF } from '../../interfaces/shipping.interface';

interface Props extends PropsFromRedux {}

const EditDropoffModal: React.FC<Props> = ({ modal, hideModal }) => {
  const { header, body } = modal?.ownProps || {};
  const dropoffsData: DROPOFF = {
    SenderName: '',
    SenderCity: '',
    ReceiverName: '',
    ReceiverAddress: '',
    CompanyType: '',
    CountryId: 0,
    CustomerCode: '',
    DateCreated: '',
    DateModified: '',
    DepartureStationId: 0,
    DestinationServiceCenterId: 0,
    DestinationStationId: 0,
    IsActive: false,
    IsAgent: false,
    IsDeleted: false,
    IsProcessed: false,
    LGA: '',
    PickupOptions: 'SERVICECENTER',
    PreShipmentId: 0,
    PreShipmentItems: [],
    ReceiverCity: '',
    ReceiverPhoneNumber: '',
    RowVersion: 0,
    SenderPhoneNumber: '',
    SenderUserId: '',
    TempCode: '',
    Value: 0,
    WalletBalance: 0,
    Waybill: '',
  };
  return (
    <ModalWrapper hideModal={hideModal}>
      <div className="w-full flex flex-col items-center justify-center">
        <h2 className="font-bold text-xl mb-5">{header || 'Edit DropOff'}</h2>
        <p>{body || ''}</p>
        <div className="w-full sm:px-10 py-1 ">
          <EditDropOffForm dropoffs={dropoffsData} />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default EditDropoffModal;
